import React from 'react';
import classnames from 'classnames';
import Statuses from '../../../../model/Statuses';
import useLayoutDirection from '../../utils/Translations/useLayoutDirection';
import styles from './Checkbox.scss';
import useT from '../../utils/Translations/useT';
import useHelpNoteTitle from '../../utils/Translations/useHelpNoteTitle';
const Checkbox = ({ value = false, onChange, label = '', status = '', inputProps = {}, isInline = true, disabled = false, className = '', isRequired = false, showToolTip = false, showStatus = false, maxLimitTooltip = '', tooltipTitle = '', }) => {
    var _a;
    const t = useT();
    const { isLayoutRTL } = useLayoutDirection();
    const resolvedTooltipTitle = useHelpNoteTitle(label, tooltipTitle);
    return (<label className={classnames(isInline && 'checkbox-inline', isLayoutRTL && styles.checkboxInlineRtlFix, className, !value && disabled && 'unSelected-radio')} title={
    // eslint-disable-next-line no-nested-ternary
    showToolTip
        ? !value
            ? maxLimitTooltip || resolvedTooltipTitle
            : resolvedTooltipTitle
        : undefined}>
      <div className={classnames('checker', isLayoutRTL && styles.checkerRtlFix)}>
        <span className={classnames({ checked: value }, !value && disabled && 'checkbox-chosen-color', value && disabled && 'checked-border')}>
          <input checked={value} className="styled" disabled={disabled} type="checkbox" onChange={onChange} {...inputProps}/>
        </span>
      </div>
      <span dir={isLayoutRTL ? 'rtl' : undefined}>
        {label}
        {showStatus && status && (<span className={classnames('text-overflow-elipsis', {
        'mr-5': isLayoutRTL,
        'ml-5': !isLayoutRTL,
        hidden: status === Statuses.Active.value,
        'text-muted': status === Statuses.Inactive.value,
        'text-danger': status === Statuses.Deleted.value,
    })} title={status}>
            {t((_a = Statuses.BasicByValue[status]) === null || _a === void 0 ? void 0 : _a.name)}
          </span>)}
      </span>
      {isRequired && <span className="text-danger">&nbsp;*</span>}
    </label>);
};
export default Checkbox;
